import { render, staticRenderFns } from "./AssetAlerts.vue?vue&type=template&id=784cc4f8"
import script from "./AssetAlerts.vue?vue&type=script&lang=js"
export * from "./AssetAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports